export default __webpack_public_path__ + "static/media/error.2df9bcc3.svg";